export default "__VITE_ASSET__B8S3vB0e__"